module.exports = __webpack_public_path__ + "static/img/ru.a36db5ee.svg";